export default __webpack_public_path__ + "static/Goodreads-9379ed06453d9ef11fa468d2db76c620.png";